import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surfaced in the browser console for debugging in any environment
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen bg-black text-white flex items-center justify-center px-6">
          <div className="max-w-lg w-full bg-[#0A0A0A] border border-[#D4AF37]/30 rounded-sm p-8 text-center">
            <h1 className="font-display font-bold uppercase text-2xl mb-3 gold-text">Algo ha fallado</h1>
            <p className="text-white/60 text-sm mb-4">
              Se ha producido un error al cargar esta pantalla. Aquí tienes el detalle:
            </p>
            <pre className="text-left text-xs text-red-300 bg-black/60 border border-white/10 rounded-sm p-3 overflow-auto max-h-40 mb-6 whitespace-pre-wrap">
              {String(this.state.error?.message || this.state.error || "Error desconocido")}
            </pre>
            <button onClick={this.handleReload} className="btn-gold rounded-sm px-6 py-3 text-sm">
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
